import React from "react";
import { useRef,useContext,useEffect,useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from "../pages/inc/Header";
import Footer from "../pages/inc/Footer";
import Popmodal from "../pages/inc/popmodal";
import Userprofile from "./Trainer/User_profile";
import Hourlysetp from "./Trainer/Hourly_setp";
import Facilitator from "./Trainer/Facilitator";
import Allvides from "./Trainer/Allvides";
import { GlobalContext } from '../GlobalContext';
import { AppRefreshContext } from '../AppRefresh';
import { useTranslation } from 'react-i18next';


function changeLanguage_main_timeSlotName(allession_data,timeSlotName){
   
  let languageCode_local = parseInt(localStorage.getItem('default_langage_code'));
    let return_value=false;
    let r_data;
      for(let y = 0; y < allession_data.languageDetailsList.length; y++){
        
        if(allession_data.languageDetailsList[y].languageDetails.languageId == languageCode_local  && allession_data.languageDetailsList[y][timeSlotName] != null){
       return_value=true;
       r_data = allession_data.languageDetailsList[y][timeSlotName];
       break;
        }else{
          r_data = allession_data[timeSlotName];
        }
        
      }

      if(!return_value){
     r_data = allession_data[timeSlotName];
      }

      return r_data;

}


function changeLanguage_main_section(allession_data,timeSlotName){
     
  let languageCode_local = parseInt(localStorage.getItem('default_langage_code'));
    let return_value=false;
    let r_data;
      for(let y = 0; y < allession_data.sectionHtmlModuleLanguages.length; y++){
        
        if(allession_data.sectionHtmlModuleLanguages[y].languageDetails.languageId == languageCode_local  && allession_data.sectionHtmlModuleLanguages[y][timeSlotName] != null){
       return_value=true;
       r_data = allession_data.sectionHtmlModuleLanguages[y][timeSlotName];
       break;
        }else{
          r_data = allession_data[timeSlotName];
        }
        
      }

      if(!return_value){
     r_data = allession_data[timeSlotName];
      }

      return r_data;
}

function convertTo12Hour(time24) {
  
  const [hourStr, minuteStr] = time24.split(':');
  let hour = parseInt(hourStr);
  const minute = minuteStr.padStart(2, '0');
  const ampm = hour >= 12 ? 'PM' : 'AM';

  hour = hour % 12;
  hour = hour ? hour : 12; // convert '0' to '12'

  return `${hour}:${minute} ${ampm}`;
}

const Home = () => {
  const { refreshApp } = useContext(AppRefreshContext);
const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const userprofile = {
    "name":"John Doe",
    "description":t('one2one_welcome_content'),
    "logo" : "img/cfn-banner-logo.svg"
  }
 const { setLogin } = useContext(GlobalContext);
    const logout_action = () => {
      localStorage.removeItem('token');
      localStorage.removeItem('name');
      localStorage.removeItem('loginbefore');
      localStorage.removeItem('role');
      setLogin(false);
     
refreshApp();
     //  window.location.replace(window.location.href);
    };

  let hours = [{
    "index": 1,
    "title": "Hour One",
    "start_time": "10:00 am",
    "end_time": "11:00 am",
    "defult": true,
     "video":[],
    "documents":[],
    "description": [
      {
        "type": "Facilitator",
        "type_flag": "1",
        "duration": "10", 
        "duration_unit": "min", 
        "title": "Welcome and Introductions", 
        "description": "Description", 
        "pdf_link": null, 
        "video": [], 
      },
      {
        "type": "Video",
        "type_flag": "2",
        "duration": "10", 
        "duration_unit": "min", 
        "title": "Prayer & Intercession - Levi Lutz", 
        "description": "Description", 
        "pdf_link": null, 
        "video": [], 
      },
      {
        "type": "Video",
        "type_flag": "2",
        "duration": "10", 
        "duration_unit": "min", 
        "title": "Prayer & Intercession - Levi Lutz", 
        "description": "Description", 
        "pdf_link": null, 
        "video": [], 
      },
    ],
  },{
    "index": 2,
    "title": "Hour Two",
    "defult": true,
    "start_time": "11:00 am",
    "end_time": "12:00 am",
     "video":[],
    "documents":[],
    "description": [
      {
        "type": "Facilitator",
        "type_flag": "1",
        "duration": "10", 
        "duration_unit": "min", 
        "title": "Welcome and Introductions", 
        "description": "Description", 
        "pdf_link": null, 
        "video": [], 
      },
      {
        "type": "Video",
        "type_flag": "2",
        "duration": "10", 
        "duration_unit": "min", 
        "title": "Prayer & Intercession - Levi Lutz", 
        "description": "Description", 
        "pdf_link": null, 
        "video": [], 
      },
      {
        "type": "Video",
        "type_flag": "2",
        "duration": "10", 
        "duration_unit": "min", 
        "title": "Prayer & Intercession - Levi Lutz", 
        "description": "Description", 
        "pdf_link": null, 
        "video": [], 
      },
    ],
  },{
    "index": 3,
    "title": "Hour Three",
    "defult": false,
    "start_time": "12:00 pm",
    "end_time": "01:00 pm",
     "video":[],
    "documents":[],
    "description": [
      {
        "type": "Facilitator",
        "type_flag": "1",
        "duration": "10", 
        "duration_unit": "min", 
        "title": "Welcome and Introductions", 
        "description": "Description", 
        "pdf_link": null, 
        "video": [], 
      },
      {
        "type": "Break",
        "type_flag": "3",
        "duration": "10", 
        "duration_unit": "min", 
        "title": "-", 
        "description": "Description", 
        "pdf_link": null, 
        "video": [], 
      },
      {
        "type": "Video",
        "type_flag": "2",
        "duration": "10", 
        "duration_unit": "min", 
        "title": "Prayer & Intercession - Levi Lutz", 
        "description": "Description", 
        "pdf_link": null, 
        "video": [], 
      },
    ],
  },{
    "index": 4,
    "title": "Hour Four",
    "defult": false,
    "start_time": "01:00 pm",
    "end_time": "02:00 pm",
     "video":[],
    "documents":[],
    "description": [
      {
        "type": "Facilitator",
        "type_flag": "1",
        "duration": "10", 
        "duration_unit": "min", 
        "title": "Welcome and Introductions", 
        "description": "Description", 
        "pdf_link": null, 
        "video": [], 
      },
      {
        "type": "Video",
        "type_flag": "2",
        "duration": "10", 
        "duration_unit": "min", 
        "title": "Prayer & Intercession - Levi Lutz", 
        "description": "Description", 
        "pdf_link": null, 
        "video": [], 
      },
      {
        "type": "Video",
        "type_flag": "2",
        "duration": "10", 
        "duration_unit": "min", 
        "title": "Prayer & Intercession - Levi Lutz", 
        "description": "Description", 
        "pdf_link": null, 
        "video": [], 
      },
    ],
  },{
    "index": 5,
    "title": "Hour Five",
    "defult": false,
    "start_time": "02:00 pm",
    "end_time": "03:00 pm",
     "video":[],
    "documents":[],
    "description": [
      {
        "type": "Facilitator",
        "type_flag": "1",
        "duration": "10", 
        "duration_unit": "min", 
        "title": "Welcome and Introductions", 
        "description": "Description", 
        "pdf_link": null, 
        "video": [], 
      },
      {
        "type": "Video",
        "type_flag": "2",
        "duration": "10", 
        "duration_unit": "min", 
        "title": "Prayer & Intercession - Levi Lutz", 
        "description": "Description", 
        "pdf_link": null, 
        "video": [], 
      },
      {
        "type": "Video",
        "type_flag": "2",
        "duration": "10", 
        "duration_unit": "min", 
        "title": "Prayer & Intercession - Levi Lutz", 
        "description": "Description", 
        "pdf_link": null, 
        "video": [], 
      },
    ],
  }];

  const sectionFacilitatorRef = useRef(null);
  const sectionallvideoRef = useRef(null);
  const sectionallresourcesRef = useRef(null);

  const sectionFacilitator = () => {
    
      sectionFacilitatorRef.current.scrollIntoView({ behavior: 'smooth' });
    
   
  };
  const sectionVideo = () => {
    
    sectionallvideoRef.current.scrollIntoView({ behavior: 'smooth' });
  
};

const sectionallresources = () => {
    
  sectionallresourcesRef.current.scrollIntoView({ behavior: 'smooth' });

};
 const [compindex,setCompindex] = useState(1);
   const triggerGrandchildRefresh = () => {
    setCompindex(prev => !prev);
  };
  const [traintimeslot,setTraintimeslot] = useState(hours);
  const [allvideolink,setAllvideolink] = useState([]);
  const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const { siteName } = useContext(GlobalContext);
      let baseUrl = siteName.baseUrl;
        let defult_endpoint = siteName.timeSlots;

        const country_code = localStorage.getItem('default_langage_code');
        
          useEffect(() => {
        
      
            const fetchSession_dat = async () => {
              const token = localStorage.getItem('token');
              

              try {
                const response = await fetch(baseUrl + defult_endpoint + 'get/all/time/slots/language?languageId='+country_code, {
              method: 'GET',
              headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
              }
            });
            console.log(response);
                if (!response.status) {
                  logout_action();
                  throw new Error('Network response was not ok');
                }
                const allession_data = await response.json();
             
                let aphour = [];
                let child_indax;
             
                let type_defult;
                let description = [];
                let section;
                let video =[];
                let documents =[];
                let type ='Break';
                let type_flag= 3;
                let allvideo =[];
                let video_details;
                let hour_title;
                let hour_timeSlotName;
                let hour_fromTime;
                let hour_endtime;
                let section_title;
                let section_duration;
                let section_timeSlotDetails;
                let section_info1;
                let section_info2;
                let languageCode_local = localStorage.getItem('default_langage_code');
                for (let i = 0; i < allession_data.length; i++) {
                  type_defult = false;
                  if(i == 0 || i == 1){
                    type_defult = true;
                  }
                  section = '';
                  hour_title = changeLanguage_main_timeSlotName(allession_data[i],'timeSlotName');
                hour_fromTime = changeLanguage_main_timeSlotName(allession_data[i],'fromTime');
                hour_endtime = changeLanguage_main_timeSlotName(allession_data[i],'toTime');
                let info_d_2 = [];
                   for(let y = 0; y < allession_data[i].sections.length; y++){
                  
                section_title = changeLanguage_main_timeSlotName(allession_data[i].sections[y],'title');
              
                    info_d_2.push(allession_data[i].sections[y].sectionHtmlContents);
                let video_type_data_are = 2;
                   if(allession_data[i].sections[y].category == "2"){
                    
                    if(allession_data[i].sections[y].videoSourceType != null ){
                      video_type_data_are = 1;
                    }
                    //add video push
                    video_details = {
                      hour_name:hour_title,
                      video_title:section_title,
                      video_link:allession_data[i].sections[y].videoLink,
                      video_type:video_type_data_are,
                      video_poster:'img/prayer-interaction.jpg',
                    };
                    video.push(video_details);
                    video_details = '';
                    type= t("video");
                    type_flag= 2;
                   }
                   if(allession_data[i].sections[y].category == "1"){
                     documents.push(allession_data[i].sections[y].documentUrl);
                    type= t("Facilitator");
                    type_flag= 1;
                   }
                   if (allession_data[i].sections[y].category == "3") {
                     type= t("break");
                    type_flag= 3;
                   }
                   
                    section = {
                       "type": type,
                        "type_flag": type_flag,
                        "duration": allession_data[i].sections[y].duration, 
                        "duration_unit": "min", 
                        "title": changeLanguage_main_timeSlotName(allession_data[i].sections[y],'title'), 
                        "description": allession_data[i].sections[y].timeSlotDetails, 
                        "pdf_link": allession_data[i].sections[y].documentUrl, 
                        "documentId":allession_data[i].sections[y].documentId, 
                        "documentUrl":allession_data[i].sections[y].documentUrl,
                        "info1":allession_data[i].sections[y].sectionHtmlContents,
                        "info2":allession_data[i].sections[y].sectionHtmlContents,
                        "sectionId":allession_data[i].sections[y].sectionId,
                        "timeSlotDetails":allession_data[i].sections[y].timeSlotDetails,
                        "videoLink": allession_data[i].sections[y].videoLink,
                        "video_type":video_type_data_are
                    };
                    description.push(section);
                    
                   }
                   console.log(description);
                   console.log('sfsdfsdf sdf sdfsdf');
                   allvideo = [...allvideo, ...video];
                 child_indax = {
                    "index": i+1,
                    "title": hour_title,
                    "start_time": convertTo12Hour(hour_fromTime),
                    "end_time": convertTo12Hour(hour_endtime),
                    "defult": type_defult,
                    "description": description,
                    "info2":info_d_2,
                    "video":video,
                    "documents":documents,
                    };
                description = [];
                video = [];
                documents = [];
                 aphour.push(child_indax);
                  }
              
                  setAllvideolink(allvideo)
                setTraintimeslot(aphour);
              } catch (error) {
               
                logout_action();
                setError(error);
                setLoading(false);
              }
            };
          
            fetchSession_dat();
          }, []);
      
          if (loading) console.log(loading);
          if (error) console.log(error);

const { check_login_data } = useContext(GlobalContext);

useEffect(() => {
  
  if(check_login_data == null){    
    navigate('/');
  }
},[]);
  return (   
    <>
    <div class="loader d-none" id="loder-tive">
	<div class="loader-content">
		<div id="loader-animation"></div>
	</div>
</div>
    <Header/>
    <Userprofile userprofile={userprofile} />
    <Hourlysetp sectionallresources={sectionallresources} sectionVideo={sectionVideo} sectionFacilitator={sectionFacilitator} hours= {traintimeslot} setTraintimeslot={setTraintimeslot} udateCompindex={setCompindex} />
    <Facilitator sectionFacilitatorRef={sectionFacilitatorRef} hours= {traintimeslot} udateCompindex={setCompindex} />
    <Allvides sectionallresourcesRef={sectionallresourcesRef} sectionallvideoRef={sectionallvideoRef} hours= {traintimeslot} allvideolink={allvideolink}/>
    <Footer/>
    <Popmodal triggerGrandchildRefresh={compindex}/>
    </>
  );
};

export default Home;